import { isCatalogPath } from '~/composables/useMainNavigation'

export default defineNuxtRouteMiddleware(async (to, from) => {
  const { user, initialized, checkAuth } = useAuth()

  // Wait for initial auth check
  if (!initialized.value) {
    await checkAuth()
  }

  // Приглашение в команду (/invite/<токен>) открывается без входа
  if (to.path.startsWith('/invite/')) return

  // Redirect to login if not authenticated
  if (!user.value && to.path !== '/login' && to.path !== '/register-team') {
    return navigateTo('/login', { replace: true })
  }

  // Redirect to home if already authenticated and trying to access login/register-team
  if (user.value && (to.path === '/login' || to.path === '/register-team')) {
    return navigateTo('/', { replace: true })
  }

  // Общий каталог — только пользователям из platform_settings.catalog_readers
  if (user.value && user.value.catalog_access === false && isCatalogPath(to.path)) {
    return navigateTo('/products/my', { replace: true })
  }
})
